export default "__VITE_ASSET__Dcl6G2Db__"